import { useEffect } from 'react';
import { useLoading } from '../contexts/LoadingContext';

export const useApiLoadingListener = () => {
  const { setLoading, setLoadingMessage } = useLoading();

  useEffect(() => {
    const handleLoadingStart = (event: CustomEvent) => {
      const message = event.detail?.message || 'Loading...';
      setLoadingMessage(message);
      setLoading(true);
    };

    const handleLoadingEnd = () => {
      setLoading(false);
    };

    // Add event listeners
    window.addEventListener('api-loading-start', handleLoadingStart as EventListener);
    window.addEventListener('api-loading-end', handleLoadingEnd);

    // Cleanup
    return () => {
      window.removeEventListener('api-loading-start', handleLoadingStart as EventListener);
      window.removeEventListener('api-loading-end', handleLoadingEnd);
    };
  }, [setLoading, setLoadingMessage]);
};
